import styled from 'styled-components'
import ChipVariantEnum from '../../enums/ChipVariant'
import pxToRem from '../../utils/pxToRem'

export const StyledChipContainer = styled.div`
  top: ${pxToRem(20)};
  right: ${pxToRem(20)};
  position: ${({ $variant }) =>
    $variant === ChipVariantEnum.primary ||
    $variant === ChipVariantEnum.tertiary
      ? 'absolute'
      : 'inherit'};
  border-radius: ${pxToRem(40)};
  background-color: ${({ theme }) => theme.colors.opacity.white20};
  backdrop-filter: blur(${pxToRem(10)});

  padding: ${({ $variant }) =>
    $variant === ChipVariantEnum.primary ||
    $variant === ChipVariantEnum.tertiary
      ? pxToRem(5)
      : `${pxToRem(5)} ${pxToRem(20)}`};
  border: ${({ theme, $variant }) =>
    $variant === ChipVariantEnum.secondary &&
    `${pxToRem(1)} solid ${theme.colors.unique.black}`};
`


export const StyledChip = styled.p`
  justify-content: center;
  display: flex;
  border-radius: ${pxToRem(20)};
  padding: ${({ $variant }) =>
    $variant === ChipVariantEnum.tertiary
      ? `${pxToRem(3)} ${pxToRem(15)}`
      : $variant === ChipVariantEnum.primary &&
        `${pxToRem(4.41)} ${pxToRem(20)} ${pxToRem(2.76)} ${pxToRem(20)}`};
  background-color: ${({ theme }) => theme.colors.opacity.white80};
  backdrop-filter: blur(${pxToRem(10)});
  font-size: ${({ theme }) => theme.fonts.sizes.md};
  line-height: ${({ theme }) => theme.fonts.lineHeight.md};
  font-weight: ${({ theme }) => theme.fonts.weight.medium};
`
